import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import classnames from 'classnames'

export default class ChartCheckbox extends React.Component {
  static propTypes = {
    checked: PropTypes.bool,
    onClick: PropTypes.func
  }

  render() {
    const {checked, onClick} = this.props
    const iconClassName = classnames('chart-checkbox', {'is-checked': checked})

    return (
      <Icon
        className={iconClassName}
        name='chart'
        size='14px'
        onClick={onClick}
        tooltip={checked ? 'Hide this metric' : 'Plot this metric'}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/TrafficReport/ChartCheckbox.js